<template>
  <template v-if="$route.name === 'home'">
    <Disclosure as="nav" class="fixed top-0 z-50 w-full bg-white shadow-md" v-slot="{ open, close }">
      <div class="mx-auto max-w-7xl px-2 sm:px-6 lg:px-8">
        <div class="relative flex h-auto items-center justify-between">
          <!-- Botón de menú móvil -->
          <div class="absolute inset-y-0 left-0 flex items-center sm:hidden">
            <DisclosureButton class="relative inline-flex items-center justify-center rounded-md p-2 text-black-300 hover:bg-gray-500 hover:text-white focus:outline-hidden focus:ring-2 focus:ring-inset focus:ring-white">
              <Bars3Icon v-if="!open" class="block h-6 w-6" aria-hidden="true" />
              <XMarkIcon v-else class="block h-6 w-6" aria-hidden="true" />
            </DisclosureButton>
          </div>

          <!-- Logo -->
          <div class="flex flex-1 items-center justify-center sm:items-stretch sm:justify-start">
            <div class="flex shrink-0 items-center">
              <router-link :to="{ path: '/' }" class="flex items-center">
                <img class="max-h-24 w-auto cursor-pointer" src="./assets/img/vsc.png" alt="Virtual Shopping Club" />
              </router-link>
            </div>

            <!-- Menú en escritorio -->
            <div class="hidden sm:ml-6 sm:block sm:items-center sm:flex">
              <div class="flex space-x-4">
                <component 
                 v-for="item in navigation" 
                 :key="item.name" 
                 :is="item.path ? 'router-link' : 'a'"
                 :to="item.path" 
                 :href="item.href"
                 class="text-black hover:bg-gray-400 hover:text-white rounded-md px-3 py-2 font-medium"
                >
                  {{ item.name }}
                </component>
              </div>
            </div>
          </div>

          <!-- Botón Suscríbete en escritorio -->
          <div class="hidden md:flex">
            <router-link :to="{ name: 'registro', params: { noPatrocinador: store.noPatrocinador } }"
              class="flex items-center justify-center h-full rounded-md bg-green-500 px-3 py-1.5 text-sm font-semibold
            leading-6 text-white shadow-sm hover:bg-green-700 focus-visible:outline focus-visible:outline-2
            focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
              Suscríbete
            </router-link>
          </div>

          <!-- Icono Suscríbete móvil -->
          <div class="md:hidden">
            <router-link :to="{ name: 'registro', params: { noPatrocinador: store.noPatrocinador } }"
              class="flex items-center justify-center h-full rounded-md bg-green-500 px-3 py-1.5 text-sm font-semibold
            leading-6 text-white shadow-sm hover:bg-green-700 focus-visible:outline focus-visible:outline-2
            focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
              <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
              </svg>
            </router-link>
          </div>
        </div>
      </div>

      <!-- Menú desplegable móvil -->
      <DisclosurePanel class="sm:hidden">
        <div class="space-y-1 px-2 pb-3 pt-2">
          <button
            v-for="item in navigation"
            :key="item.name"
            @click="handleMobileNav(item, close)"
            class="block w-full text-left rounded-md px-3 py-2 text-base font-medium text-black hover:bg-gray-500 hover:text-white"
          >
            {{ item.name }}
          </button>
        </div>
      </DisclosurePanel>
    </Disclosure>
  </template>

  <div>
    <router-view />
  </div>

  <footer class="flex min-h-full flex-1 flex-col justify-center bg-black">
    <div class="sm:mx-auto sm:w-full text-center">
      <p class="my-10 text-gray-100 leading-10">Copyright © 2025 - Virtual Shopping Club</p>
    </div>
  </footer>
</template>

<script setup>
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/vue'
import { Bars3Icon, XMarkIcon } from '@heroicons/vue/24/outline'
import { useRouter, useRoute } from 'vue-router'
import { useVSCStore } from '@/store'

const store = useVSCStore()
const router = useRouter()
const route = useRoute()

const navigation = [
  { name: 'VSC', href: '#VSC' },
  { name: 'Clubs de sinergia', href: '#clubs' },
  { name: 'Iniciativa nacional', href: '#vidaDigna' },
  { name: 'Paquetes', href: '#Paquetes' },
  { name: 'Conocenos', path: '/conocenos' },
]

// Cierra el menú desplegable y navega
function handleMobileNav(item, close) {
  if (item.path) {
    router.push(item.path).then(() => close())
  } else if (item.href) {
    // Navega a sección anclada si estás en home
    if (route.path !== '/') {
      router.push('/').then(() => {
        scrollToHash(item.href)
        close()
      })
    } else {
      scrollToHash(item.href)
      close()
    }
  }
}

function scrollToHash(hash) {
  setTimeout(() => {
    const el = document.querySelector(hash)
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' })
    }
  }, 300)
}
</script>

<style scoped>
/*AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA*/
/*@font-face {
  font-family: "Open Sans ExtraBold";
  src: local("Open Sans ExtraBold"), local("OpenSans-ExtraBold"), url("@/assets/fonts/OpenSans-ExtraBold-webfont.woff")
    format('woff');
  font-weight: normal;
  font-style: normal;
}*/
</style>
